module.exports = __webpack_public_path__ + "static/img/9.c515986.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/sp/9.png
// module id = amVc
// module chunks = 0